import { spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';
export const tabsRowClass = style({
  display: 'flex',
});

export const tabsNavigationWrapperClass = style({
  display: 'flex',
  marginBottom: spacingVars['3xl'],
});
